<template>
    <div class="accountTeam wrap_over"  v-loading="orderloading">
        <div class="search" >
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="對賬時間">
                        <el-date-picker
                            v-model="reconDate"
                            type="month"
                            :clearable="false"
                            :picker-options="pickerOptions2"
                            @change='monthChange()'
                            placeholder="选择月">

                        </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="reconciliation" type="primary" :disabled="acState !== 0">
                      <span v-if="acState == 0">确认对账</span>
                      <span v-if="acState == 1">已对账</span>
                      <span v-if="acState == 3">无数据</span>
                    </el-button>
                    <span v-if="acState == 0" style="margin-left:10px;">对账有疑问，<el-button type="text" @click="updateAcState">发起申述</el-button>
                    <el-popover
                            placement="top-start"
                            title="對帳說明"
                            width="300"
                            trigger="hover"
                            content="您對結算金額有異議的話，可以點擊“發起申述”，我們將收到您的申述通知，並第一時間聯繫您盡快完成對賬操作，感謝您的支持！">
                            <i class="el-icon-question" slot="reference"></i>
                    </el-popover>
                    </span>
                </el-form-item>
            </el-form>
        </div>
        <div class="amount">
                 <el-row>
                    <el-col :span="6">
                        <div style="margin-bottom: 10px;font-size: 12px;">正常包裹计费總重量
                            <el-popover
                            placement="top-start"
                            title="正常包裹计费總重量"
                            width="300"
                            trigger="hover"
                            content="正常包裹计费總重量=正常包裹计费重量之和">
                            <i class="el-icon-question" slot="reference"></i>
                        </el-popover></div>
                        <span style="font-size: 18px;">{{accordingTotal.totalWeight | formaleft}}</span>
                        <span class="cs">{{accordingTotal.totalWeight | forma3Right}}KG</span>
                    </el-col>
                    <el-col :span="6">
                        <div style="margin-bottom: 10px;font-size: 12px;">異常包裹计费總重量                        <el-popover
                            placement="top-start"
                            title="異常包裹计费總重量"
                            width="300"
                            trigger="hover"
                            content="異常包裹计费總重量=所有異常狀態為含違禁品+退運狀態的包裹重量總和">
                            <i class="el-icon-question" slot="reference"></i>
                        </el-popover></div>
                        <span style="font-size: 18px;">{{accordingTotal.totalEptWeight | formaleft}}</span>
                        <span class="cs">{{accordingTotal.totalEptWeight | forma3Right}}KG</span>
                    </el-col>
                    <el-col :span="6">
                        <div style="margin-bottom: 10px;font-size: 12px;">供應商結算金額
                          <el-popover
                            placement="top-start"
                            title="對賬說明"
                            width="300"
                            trigger="hover"
                            content="供應商結算金額=正常包裹的（重量總和*供應商每公斤結算價格）+異常包裹的（重量總和*供應商每公斤結算價格）">
                            <i class="el-icon-question" slot="reference"></i>
                        </el-popover></div>
                        <span style="font-size: 18px;"><span style="font-size: 12px;">$</span>{{accordingTotal.realSettleTotalAmt | formaleft}}</span>
                        <span class="cs">{{accordingTotal.settleAmount | formaRight}}</span>
                    </el-col>
                    <el-col :span="6">
                      <div class="export">
                          <el-button @click="createCollectPoint" type="primary">導出</el-button>
                      </div>
                    </el-col>
                 </el-row>
        </div>
       <div class="table-container">
            <el-table
                    :data="orderListData"
                    style="width: 100%">
                    <el-table-column  prop="outTradeNo" label="快遞單號"></el-table-column>
                    <el-table-column label="入庫時間">
                        <template slot-scope="scope">
                          {{scope.row.creatTime |timeTransform}}
                        </template>
                    </el-table-column>
                    <el-table-column  prop="weightType" label="計費重量類型">
                        <template slot-scope="scope">
                            {{scope.row.weightType |  weightTypeID}}
                        </template>
                    </el-table-column>
                    <el-table-column  prop="weight" label="包裹重量（KG）"></el-table-column>
            </el-table>
            <div class="pageContainer"
                    v-if="totalCount/pageSize>1">
                    <el-pagination @size-change="handleSizeChange"
                                @current-change="watchPageNow"
                                :current-page.sync="pageNo"
                                :page-sizes="[10, 20, 30]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalCount">
                    </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { timeFilter } from '@/filters/index'
import { parseExportLink } from '@/utils/index.js'
import { checkAccount,
  getData,
  getCustAcState,
  getStatistic,
  updateAppealState } from '@/api/captain'
export default {
  name: 'reconciliation',
  data () {
    return {
      pickerOptions2: {
        disabledDate (time) {
          const strDate = (new Date().getDate())
          return time.getTime() > (Date.now() - (strDate * 24 * 3600 * 1000)) - 8.64e6
        }
      },
      reconDate: Date.now() - (((new Date().getDate()) + 1) * 24 * 3600 * 1000),
      orderListData: [],
      accordingTotal: {},
      otherRadio: 1,
      loading: false,
      orderloading: false,
      isDisable: false,
      collections: [],
      pageSize: 10,
      pageNo: 1,
      totalCount: '',
      orderDetails: {},
      acState: 3
    }
  },
  computed: {
  },
  mounted: function () {
    this.getData()
    this.getStatistic()
    this.getCustAcState()
  },
  methods: {
    changeStamp (date) {
      if (date) {
        return date.getTime()
      }
      return ''
    },
    // 对账
    reconciliation () {
      this.$confirm('確認對賬後,該代收點本月的對帳狀態變更為已對賬', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          date: this.reconDate
        }
        checkAccount({ params })
          .then(res => {
            this.$message({
              message: '對賬成功',
              type: 'success'
            })
            this.getCustAcState()
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 发起申述
    updateAcState () {
      this.$confirm('是否提交申述', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          date: this.reconDate
        }
        updateAppealState({ params })
          .then(res => {
            this.$message({
              message: '申述成功',
              type: 'success'
            })
            this.getCustAcState()
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消申述'
        })
      })
    },
    monthChange () {
      this.pageSize = 10
      this.pageNo = 1
      this.reconDate = this.changeStamp(this.reconDate)
      this.getData()
      this.getStatistic()
      this.getCustAcState()
    },
    // 列表
    getData () {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        date: this.reconDate
      }
      this.orderloading = true
      getData({ params })
        .then(res => {
          this.orderListData = res.list
          this.totalCount = res.total
          this.orderloading = false
        })
        .finally(e => {
          this.orderloading = false
        })
    },
    // 总数据
    getStatistic () {
      const params = {
        date: this.reconDate
      }
      getStatistic({ params })
        .then(res => {
          this.accordingTotal = res
        })
    },
    // 对账状态
    getCustAcState () {
      const params = {
        date: this.reconDate
      }
      getCustAcState({ params })
        .then(res => {
          this.acState = res.acState
        })
    },
    createCollectPoint () {
      const params = {
        date: this.reconDate,
        storeId: localStorage.getItem('id')
      }
      window.location.href = parseExportLink('base', '/aomi-transport/tsacCustomer/orderExport', params)
    },
    // 订单类
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getData()
    },
    watchPageNow (pageNo) {
      this.pageNo = pageNo
      this.getData()
    }
  },
  filters: {
    timeTransform: timeFilter,
    refundTypeForm: function (value) {
      const STATUS = {
        1: '部分退款',
        2: '代收点赔付'
      }
      return STATUS[value]
    },
    weightTypeID: function (value) {
      const STATUS = {
        1: '实重',
        2: '体积重'
      }
      return STATUS[value]
    },
    formaleft: function (money) {
      if (money && money != null) {
        money = String(money)
        var left = money.split('.')[0]
        //  right = money.split('.')[1]
        // right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00'
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g)
        return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('')
      } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return '0'
      } else {
        return '0'
      }
    },
    formaRight: function (money) {
      if (money && money != null) {
        money = String(money)
        var right = money.split('.')[1]
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00'
        // var temp = left.split('').reverse().join('').match(/(\d{1,3})/g)
        return right
        //  (Number(money) < 0 ? "-" : "") + temp.join(',').split('').reverse().join('')
      } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return ''
      } else {
        return ''
      }
    },
    forma3Right: function (money) {
      if (money && money != null) {
        money = String(money)
        var right = money.split('.')[1]
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 3) : '.' + right + '00') : '.000'
        // var temp = left.split('').reverse().join('').match(/(\d{1,3})/g)
        return right
        //  (Number(money) < 0 ? "-" : "") + temp.join(',').split('').reverse().join('')
      } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return ''
      } else {
        return ''
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" type="text/scss">
.accountTeam{
  padding: 20px;
  .amount{
    padding: 20px;
    border-bottom: 1px solid #EBE7E8;
    .cs{
      font-size: 12px;
    }
  }
  .export{
      padding: 20px;
      text-align: right;
  }
}
</style>
